<template>
  <b-table show-empty striped hover class="aco-table"
           :items="events" :fields="eventFields">
    <template slot="empty">
      <div class="text-center">{{ $t('noResults')}}</div>
    </template>

    <template v-slot:cell(show_details)="row">
      <router-link v-if="isOrderObjectReference(row.item.objectReference)"
                   :to="{ name: 'OrderDetails', params: { id: getObjectReference(row.item.objectReference) }}">
        <b-button size="sm" class="py-0" >{{ $t('openOrder')}}</b-button>
      </router-link>
      <router-link v-if="isUserObjectReference(row.item.objectReference)"
                   :to="{ name: 'UserDetails', params: { id: getObjectReference(row.item.objectReference) }}">
        <b-button size="sm" class="py-0" >{{ $t('openUser')}}</b-button>
      </router-link>
      <router-link v-if="isProductObjectReference(row.item.objectReference)"
                   :to="{ name: 'ProductDetails', params: getProductReference(row.item.objectReference) }">
        <b-button size="sm" class="py-0" >{{ $t('openProduct')}}</b-button>
      </router-link>
    </template>

  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {

    name: 'EventList',
    extends: BaseComponent,

    created: function () {
      this.$store.dispatch('events/getEvents')
    },

    computed: {
      ...mapGetters('events', ['events']),
      eventFields () {
        return [
          { key: 'application', label: this.$t('application'), tdClass: 'text-nowrap' },
          { key: 'category', label: this.$t('category'), tdClass: 'text-nowrap' },
          { key: 'message', label: this.$t('message'), tdClass: 'aco-message-text-width' },
          { key: 'created', label: this.$t('created'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'lastSeen', label: this.$t('lastSeen'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'timesSeen', label: this.$t('timesSeen') },
          { key: 'show_details', label: '', tdClass: 'text-nowrap' }
        ]
      }
    },
    methods: {
      isOrderObjectReference (value) {
        return (value != null && value.startsWith("order:"))
      },
      isUserObjectReference (value) {
        return (value != null && value.startsWith("user:"))
      },
      isProductObjectReference (value) {
        return (value != null && value.startsWith("product:"))
      },
      getObjectReference (objectReference) {
        return objectReference.split(':').pop();
      },
      getProductReference (objectReference) {
        let reference = objectReference.split(':').pop().split('/');
        return {
          source: reference[0],
          sourceId: reference[1]
        }
      }
    }
  }
</script>
